<template>
  <div class="plain-link"
    :data-tippy-content="toolTip">
    <button v-if="isFavorite"
            :class="bounceClass"
            class="text-yellow-400 hover:text-gray-500"
            @click="destroyFavorite">
                        <span
                            :style="fontSizeString"
                            class="lnr icon-star">
                        </span>
    </button>
    <button v-if="!isFavorite"
            :class="bounceClass"
            class="text-yellow-400 hover:text-gray-500"
            @click="storeFavorite">
                        <span
                            :style="fontSizeString"
                            class="lnr icon-star-empty">
                        </span>
    </button>
  </div>
</template>

<script>
import axios from "axios";
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import tippy from 'tippy.js';

export default {
  name: "meterFavorite",
  mixins: [SonicuCoreMixin],
  props: {
    favorite: {
      type: Boolean,
      default: false,
    },
    meterId: {
      type: [Number, String],
    },
    fontSizeRem: {
      type: String,
      default: '1.5'
    }
  },
  mounted(){
    this.tippyInstance = tippy('[data-tippy-content]');
  },
  data(){
    return {
      isFavorite: this.favorite,
      bounceClass: '',
      tippyInstance: null,
    }
  },
  methods: {
    storeFavorite() {
      axios.post(
          this.company.buildCompanyApiInternalRoute('meters/favorite/'),
          {
            'meter_id': this.meterId,
          }
      ).then(
          response => {
            this.isFavorite = true;
            this.bounceClass = 'animate-bounce';
            setTimeout(() => this.bounceClass = '', 1000);
          }
      )
    },
    destroyFavorite() {
      axios.delete(this.company.buildCompanyApiInternalRoute('meters/favorite/' + this.meterId)).then(
          response => {
            this.isFavorite = false;
            this.bounceClass = 'animate-bounce';
            setTimeout(() => this.bounceClass = '', 1000);
          }
      )
    },
    setTippy(){
      this.tippyInstance[0].setContent(this.toolTip);
    }
  },
  computed: {
    toolTip(){
      return this.isFavorite ? 'Remove from favorites' : 'Add to favorites';
    },
    fontSizeString(){
      return 'font-size: ' + this.fontSizeRem + 'rem;';
    }
  },
  watch: {
    isFavorite: function(val){
      this.setTippy();
    }
  }
}
</script>

<style scoped>

</style>